import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'app/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  public baseUrl: string;
  public newbaseUrl: string;
  selectedDashboardData: any = {};
  selectedTimeConfigData: any = {};
  selectedbillConfigData:any = {}
  selectedsearchbillData:any = {};
  selecteEmailData: any = {};
  selecteddate = this.datePipe.transform(this.authservice.getServerDate, "yyyy-MM-dd")
  constructor(public http: HttpClient, public authservice: AuthService,public snackBar: MatSnackBar,private datePipe: DatePipe,) {
    this.baseUrl = this.authservice.baseUrl;
    this.newbaseUrl = this.authservice.newbaseUrl;
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    })
  }
  getHospitalManagerConfig() {
    return this.http.get<any>(this.newbaseUrl + "Configuration/GetHospitalManagerConfiguration")
  }
  getBranchMaster() {
    return this.http.get<any>(this.newbaseUrl + "branchMaster/getBranch/0")
  }

  getDashboardConfig(type) {
    return this.http.get<any>(this.newbaseUrl + "Configuration/GetDashboardConfiguration/"+type)
  }

  getDashboardConfigItem(id: any) {
    return this.http.get<any>(this.newbaseUrl + "Configuration/GetDashboardConfiguration/" + id)
  }

  addDashboardConfig(data: any) {
    return this.http.post<any>(this.newbaseUrl + "Configuration/InsertDashboardConfiguration", data)
  }

  updateDashboardConfig(data: any) {
    return this.http.post<any>(this.newbaseUrl + "Configuration/InsertDashboardConfiguration", data)
  }

  getTimeConfig() {
    return this.http.get<any>(this.newbaseUrl + "Common/GetOPDManagerDashboardTimeAndColorConfiguration")
  }

  addTimeConfig(data: any) {
    return this.http.post<any>(this.newbaseUrl + "Configuration/InsertTimeConfiguration", data)
  }

  updateTimeConfig(data: any) {
    return this.http.post<any>(this.newbaseUrl + "Configuration/InsertTimeConfiguration", data)
  }

  getWorkupConfig() {
    return this.http.get<any>(this.newbaseUrl + "Configuration/GetWorkupConfiguration")
  }

  updateWorkupConfig(data: any) {
    return this.http.post<any>(this.newbaseUrl + "Configuration/UpdateWorkupConfiguration", data)
  }

  addEmailConfig(data: any) {
    return this.http.post<any>(this.newbaseUrl + "Email/InsertEmailConfiguration", data)
  }

  emailConfigType(id:any) {
    return this.http.get<any>(this.newbaseUrl + "Email/ConfigEmail/" + id)
  }
  getEmailType() {
    return this.http.get<any>(this.newbaseUrl + "Email/GetEmailType" )
  }

  getSendType() {
    return this.http.get<any>(this.newbaseUrl + "Email/GetEmailSendingType")
  }

  getTemplateType() {
    return this.http.get<any>(this.newbaseUrl + "Email/GetEmailTemplateType")
  }

  GetBillingConfigurationSetupByBillConfigurationId(configurationId:any){
    return this.http.get<any>(this.newbaseUrl + "Configuration/GetBillingConfigurationSetupByBillConfigurationId/" + configurationId)
  }


  InsertBillingConfigurationSetup(payload){
    return this.http.post<any>(this.newbaseUrl+"Configuration/InsertBillingConfigurationSetup",payload)
  } 

  GetBillingFooterNarrationByBranchId(branchId){
    return this.http.get<any>(this.newbaseUrl + "Configuration/GetBillingFooterNarrationByBranchId/" + branchId)
  }

  GetrateListApi(branchId,speId){
    return this.http.get<any>(this.newbaseUrl + "RateList/GetRateListMasterByBranchIdBySpecialityIdModule/"+ branchId + "/" + speId)
  }

  GetReferredByShareDetailApi(branchId,refId){
    return this.http.get<any>(this.newbaseUrl + "Masters/GetReferredByShareDetailByBranchIdByReferredbyId/"+ branchId + "/" + refId)
  }
  InsertReferredByShareDetail(data){
    return this.http.post<any>(this.newbaseUrl + "Masters/InsertReferredByShareDetail", data)
  }

  GetNameByType(){
    return this.http.get<any>(this.newbaseUrl + "Common/GetNameByType/WEEKDAYS")
  }

  GetDoctorOPDScheduleMaster(data){
    return this.http.post<any>(this.newbaseUrl + "Masters/GetDoctorOPDScheduleMaster", data)
  }
  
  InsertDoctorOpdScheduleMaster(data){
    return this.http.post<any>(this.newbaseUrl + "Masters/InsertDoctorOpdScheduleMaster", data)
  }

  GetScheduleTypeMaster(){
    return this.http.get<any>(this.newbaseUrl + "Masters/GetScheduleTypeMaster") 
  }

  getSpeciltiyList(specid) {
    return this.http.get(this.newbaseUrl + "Common/GetSubSpeciality/" + specid + '/' + this.authservice.Loggeduser.specialityId );
  }

  get_drsbysubspecilityId(branchid:any,specId:any) {
    return this.http.get<any>(this.newbaseUrl + "VisitMaster/GetUserListBySubSpecialityId/6"
      + "/" + branchid + "/" + this.selecteddate + "/6/" + specId +'/'+this.authservice.Loggeduser.specialityId);
  }

  InsertDoctorScheduleMasterOpd(data){
    return this.http.post<any>(this.newbaseUrl + "Masters/InsertDoctorScheduleMasterOpd",data)
  }

  // Appilcation setting Api...
  GetApplicationSetting(){
    return this.http.get<any>(this.newbaseUrl + "Configuration/GetApplicationSetting/0")
  }

  InsertApplicationSetting(data){
    return this.http.post<any>(this.newbaseUrl + "Configuration/InsertApplicationSetting",data)
  }

  getBrachMaster() {
    return this.http.get<any>(this.newbaseUrl + "BranchMaster/GetBranch/" + 0)
  }


  SMSTEMPLATEPARAMETERS(){
    return this.http.get<any>(this.newbaseUrl + "Common/GetNameByType/SMSTEMPLATEPARAMETERS") 
  }
  SMSTEMPLATENAMESPELLING(){
    return this.http.get<any>(this.newbaseUrl + "Common/GetNameByType/SMSTEMPLATENAMESPELLING")
  }
  SMSSendingType(){
    return this.http.get<any>(this.newbaseUrl + "Common/GetNameByType/SMSSendingType")
  }
  GetSmsMasterConfigurationByBranchId(id){
    return this.http.get<any>(this.newbaseUrl + "SendSMS/GetSmsMasterConfigurationByBranchId/" + id)
  }

  InsertSmsConfiguration(payload:any){
    return this.http.post<any>(this.newbaseUrl + "SendSMS/InsertSmsConfiguration", payload)
  }
  GetPatientConfigurationSetup(id){
    return this.http.get<any>(this.newbaseUrl + "Configuration/GetPatientConfigurationSetup/" + id) 
  }
  InsertPatientConfigurationSetup(payload:any){
    return this.http.post<any>(this.newbaseUrl + "Configuration/InsertPatientConfigurationSetup", payload)
  }
  GetSmsTemplateMasterByBranchIdByTranId(id: any, id1: any) {
    return this.http.get<any>(`${this.newbaseUrl}SendSMS/GetSmsTemplateMasterByBranchIdByTranId/${id}/${id1}`);
  }
  InsertSmsTemplateMaster(payload:any){
    return this.http.post<any>(this.newbaseUrl + "SendSMS/InsertSmsTemplateMaster", payload)
  }
  
  getpopupHelp(flag){
    return this.http.get<any>(this.newbaseUrl + "Common/GetPopUpHelp/"+ flag)
  }
  initialMatsr(){
    return this.http.get<any>(this.newbaseUrl + "InitialMaster")
  }
}
